import axios from 'axios';

export class UncubesHTTPController {
  static #instance = null;

  axios = null;

  constructor(token) {
    this.axios = axios.create({
      headers: { Authorization: `Bearer ${token}` },
      baseURL: process.env.VUE_APP_UNCUBES_SERVER_URL
    });
  }

  static initialize(token) {
    if (!this.#instance && token && token !== '') {
      this.#instance = new UncubesHTTPController(token);
    }
  }

  static getInstance() {
    return this.#instance?.axios;
  }
}
